/** @type {import('tailwindcss').Config} */
const plugin = require('tailwindcss/plugin');

module.exports = {
	content: ['./**/*.php', './src/**/*.js', './blocks/**/*.js'],
	theme: {
		transitionTimingFunction: {
			DEFAULT: 'ease',
		},
		transitionDuration: {
			DEFAULT: '300ms',
		},
		boxShadow: {
			DEFAULT: '0px 20px 50px -12px rgba(0, 51, 102, 0.10)',
			sm: '0 1px 1px 0 rgba(0, 51, 102, 0.10)',
			lg: '0px 16px 70px -12px rgba(0, 51, 102, 0.08)',
			none: 'none',
		},
		colors: {
			primary: {
				DEFAULT: 'rgb(from var(--color-primary) r g b / <alpha-value>)',
				80: 'rgb(from var(--color-primary-80) r g b / <alpha-value>)',
				20: 'rgb(from var(--color-primary-20) r g b / <alpha-value>)',
				15: 'rgb(from var(--color-primary-15) r g b / <alpha-value>)',
				10: 'rgb(from var(--color-primary-10) r g b / <alpha-value>)',
				dark: 'color-mix(in srgb, var(--color-primary), black 20%)',
			},
			secondary: {
				DEFAULT: 'rgb(from var(--color-secondary) r g b / <alpha-value>)',
				90: 'rgb(from var(--color-secondary-90) r g b / <alpha-value>)',
				80: 'rgb(from var(--color-secondary-80) r g b / <alpha-value>)',
				70: 'rgb(from var(--color-secondary-70) r g b / <alpha-value>)',
				50: 'rgb(from var(--color-secondary-50) r g b / <alpha-value>)',
				30: 'rgb(from var(--color-secondary-30) r g b / <alpha-value>)',
				20: 'rgb(from var(--color-secondary-20) r g b / <alpha-value>)',
				10: 'rgb(from var(--color-secondary-10) r g b / <alpha-value>)',
				5: 'rgb(from var(--color-secondary-5) r g b / <alpha-value>)',
			},
			tertiary: {
				DEFAULT: 'rgb(from var(--color-tertiary) r g b / <alpha-value>)',
				75: 'rgb(from var(--color-tertiary-75) r g b / <alpha-value>)',
				50: 'rgb(from var(--color-tertiary-50) r g b / <alpha-value>)',
				25: 'rgb(from var(--color-tertiary-25) r g b / <alpha-value>)',
				15: 'rgb(from var(--color-tertiary-15) r g b / <alpha-value>)',
				5: 'rgb(from var(--color-tertiary-5) r g b / <alpha-value>)',
			},
			quaternary: {
				DEFAULT: 'rgb(from var(--color-quaternary) r g b / <alpha-value>)',
			},
			accent: {
				DEFAULT: 'rgb(from var(--color-accent) r g b / <alpha-value>)',
				40: 'rgb(from var(--color-accent-40) r g b / <alpha-value>)',
				alt: 'rgb(from var(--color-accent-alt) r g b / <alpha-value>)',
				dark: 'color-mix(in srgb, var(--color-accent), black 5%)',
			},
			gray: {
				DEFAULT: 'rgb(from var(--color-gray) r g b / <alpha-value>)',
				light: 'rgb(from var(--color-gray-light) r g b / <alpha-value>)',
			},
			white: {
				DEFAULT: 'rgb(from var(--color-white) r g b / <alpha-value>)',
			},
			black: 'rgb(from var(--color-black) r g b / <alpha-value>)',
			alert: 'rgb(from var(--color-alert) r g b / <alpha-value>)',
			transparent: 'transparent',
			socials: {
				facebook: '#3a579b',
				facebookmsg: '#168AFF',
				x: '#000',
				youtube: '#ff0000',
				linkedin: '#0a66c2',
				instagram: '#7232bd',
				pinterest: '#bd081c',
				tiktok: '#010101',
				whatsapp: '#25d366',
			},
		},
		fontSize: {
			xs: 'var(--text-xs)',
			sm: 'var(--text-sm)',
			base: 'var(--text-base)',
			lg: 'var(--text-lg)',
			xl: 'var(--text-xl)',
			h1: 'var(--text-h1)',
			h2: 'var(--text-h2)',
			h3: 'var(--text-h3)',
			h4: 'var(--text-h4)',
			h5: 'var(--text-h5)',
			h6: 'var(--text-h6)',
		},
		fontFamily: {
			body: 'var(--font-body)',
			heading: 'var(--font-heading)',
			icons: 'var(--font-icons)',
		},
		extend: {
			backgroundImage: {
				radial: 'radial-gradient(var(--tw-gradient-stops))',
			},
			borderRadius: {
				'4xl': '32px',
			},
			lineHeight: {
				relaxed: '1.75',
			},
			screens: {
				'3xl': '1921px',
			},
			gap: {
				x: {
					auto: 'var(--strl-gap)',
				},
				y: {
					auto: 'var(--strl-gap)',
				},
				auto: 'var(--strl-gap)',
			},
			flex: {
				'col-1': '0 0 calc(var(--strl-column-size) * 1)',
				'col-2': '0 0 calc(var(--strl-column-size) * 2 + var(--strl-gap))',
				'col-3': '0 0 calc(var(--strl-column-size) * 3 + 2 * var(--strl-gap))',
				'col-4': '0 0 calc(var(--strl-column-size) * 4 + 3 * var(--strl-gap))',
				'col-5': '0 0 calc(var(--strl-column-size) * 5 + 4 * var(--strl-gap))',
				'col-6': '0 0 calc(var(--strl-column-size) * 6 + 5 * var(--strl-gap))',
				'col-7': '0 0 calc(var(--strl-column-size) * 7 + 6 * var(--strl-gap))',
				'col-8': '0 0 calc(var(--strl-column-size) * 8 + 7 * var(--strl-gap))',
				'col-9': '0 0 calc(var(--strl-column-size) * 9 + 8 * var(--strl-gap))',
				'col-10': '0 0 calc(var(--strl-column-size) * 10 + 9 * var(--strl-gap))',
				'col-11': '0 0 calc(var(--strl-column-size) * 11 + 10 * var(--strl-gap))',
				full: '0 0 100%',
			},
		},
	},
	plugins: [
		plugin(function ({ addVariant, addComponent }) {
			addVariant('hocus', ['&:hover', '&:focus-visible']);
		}),
	],
	safelist: [
		{
			pattern: /grid-cols-(1[0-2]|[1-9])/,
			variants: ['sm', 'md', 'lg', 'xl'],
		},
		{
			pattern: /facetwp-([a-z])/,
		},
	],
};
